module.exports = __webpack_public_path__ + "static/media/main_background.db2a986f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main_background.png
// module id = 847
// module chunks = 0